function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFirstPhase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.97974,67.0468h2.53463V31.93206c0-3.23287-1.95509-6.354-4.364-6.354-2.402,0-4.35705,3.12116-4.35705,6.354V60.15512",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.14675,67.0468H32.43058V31.93206c0-3.23287,1.9481-6.354,4.357-6.354s4.35705,3.12116,4.35705,6.354V60.4833",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.78932,93.03548l8.32308-2.30421A22.93752,22.93752,0,0,0,45.35509,76.96886",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.68912,76.96886A22.26764,22.26764,0,0,0,71.40661,90.26345l14.35592,2.793",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "41.878 69.707 42.59 72.954 31.146 72.954 32.459 66.963 35.175 66.963",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "66.959 66.963 69.465 66.963 70.778 72.954 59.334 72.954 60.046 69.707",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.22148,60.4414V19.60105c0-5.35554,4.34308-12.26816,9.69862-12.26816s9.69863,6.91262,9.69863,12.26816V60.02246",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "60.619 69.707 60.619 69.784 41.221 69.784 41.221 69.707",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.346 76.966 41.928 76.966 44.045 69.744 58.229 69.744 60.346 76.966",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.21818,69.70629H67.34244a9.81724,9.81724,0,0,0-5.20816-8.67272,9.1778,9.1778,0,0,1-4.9161-8.07286l0-14.94943A8.64443,8.64443,0,0,0,54.9109,32.054c-4.698-4.95654-9.58329,1.24069-9.58329,5.68892V53.28936A8.071,8.071,0,0,1,40.672,60.71475a9.8048,9.8048,0,0,0-5.87809,8.99154H57.21818Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.15614,
    y1: 93.03131,
    x2: 89.15614,
    y2: 93.03131,
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.66572,
    y1: 64.8775,
    x2: 53.66572,
    y2: 66.61708,
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.66572,
    y1: 57.94115,
    x2: 53.66572,
    y2: 61.28088,
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "53.666 34.814 53.666 49.206 53.666 52.161",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1395,81.87612a10.69847,10.69847,0,0,0,4.68577,5.71043",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.33772,82.55912A10.83351,10.83351,0,0,1,43.33,86.9486",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.99053,86.01586A20.809,20.809,0,0,1,45.569,92.179",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.7121,
    y1: 21.44093,
    x2: 51.09056,
    y2: 21.44093,
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.31154,
    y1: 21.44093,
    x2: 57.62288,
    y2: 21.44093,
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3964899681371796px"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFirstPhase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/first-phase.d08e4ea79e1cb1f95ad2af9045d44bc9.svg";